module.exports = __webpack_public_path__ + "static/media/logo-dark.2dfec859.png";